import { selector } from "recoil";
import {
  defaultRequisitions,
  providerState,
  providerProfileState,
  missingRequisitions,
  orderedRequisitions,
} from "./atoms";
import { TotalsCount } from "./types";

export const getUserAuth = selector({
  key: "userAuth",
  get: ({ get }) => get(providerState),
});

export const getUserProfile = selector({
  key: "userProfile",
  get: ({ get }) => get(providerProfileState),
});

export const getAllDefaultRequisitions = selector({
  key: "allRequisitions",
  get: ({ get }) => get(defaultRequisitions),
});

export const getTotalRequisitions = selector({
  key: "totalRequisitions",
  get: ({ get }) => {
    const reqs = get(defaultRequisitions);
    return (
      reqs &&
      ({
        totalReqsCount: reqs.total_count,
        totalCompletedCount: reqs.total_completed,
        totalProcessingCount: reqs.total_processing,
      } as TotalsCount)
    );
  },
});

export const getAllMissingRequisitions = selector({
  key: "allMissingRequisitions",
  get: ({ get }) => get(missingRequisitions),
});

export const getAllOrderedRequisitions = selector({
  key: "allOrderedRequisitions",
  get: ({ get }) => get(orderedRequisitions),
});
